import { Chip, Skeleton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';
interface FactorProps {
  factor: number;
  trend?: 'red' | 'yellow' | 'green' | null;
  isLoading?: boolean;
}

const trendColorMap = {
  red: 'error',
  yellow: 'warning',
  green: 'success',
} as const;

const trendIconMap = {
  red: 'trending_down',
  yellow: 'trending_flat',
  green: 'trending_up',
};

export const Factor = ({ factor, trend, isLoading }: FactorProps) => {
  const { t } = useTranslation('ui');
  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Typography variant="labelMono" align="right" color="primary">
        {t('factor.Label')}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" width={40} />
      ) : (
        <>
          <Typography variant="labelMono" color="primary">
            {factor.toFixed(2)}
          </Typography>
          {trend && (
            <Chip
              label={
                <Icon name={trendIconMap[trend]} color={trendColorMap[trend]} />
              }
              color={trendColorMap[trend]}
              size="small"
            />
          )}
        </>
      )}
    </Stack>
  );
};
